export default __webpack_public_path__ + "static/media/T19.ef5568f0.png";